module.exports = __webpack_public_path__ + "img/in-use-nan-young-kim@1x.dd9ab43a.jpg";